/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "antd";
import { parentMaster } from "../../config/parentMaster";
import MasterCard from "../../components/Master/MasterCard/MasterCard";
import MasterSearch from "../../components/Master/MasterSearch";
import McnCounts from "./McnCounts";
import LockingManagement from "./LockingManagement";
import PendingAwbs from "./LockingManagement/PendingAwbs";
import "./index.scss";

const Master = () => {
  const [masterList, setMasterList] = useState([]);
  const [currentPageRules, setCurrentPageRules] = useState({});
  const [inputSearchValue, setInputSearchValue] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    let role = JSON.parse(localStorage.getItem("userinfo"));
    let temp = [];
    let currentPageData = parentMaster.find((e) => e.mainRoute === window.location.pathname);
    currentPageData.masterData.map((e) => {
      e.role.some((item) => {
        if (role && role.roles.includes(item)) {
          temp.push(e);
        }
      });
    });
    setCurrentPageRules(currentPageData.masterProperty);
    setMasterList(temp);
  }, []);

  const {
    searchPresent,
    searchPlaceholder,
    headingTitle
  } = currentPageRules;

  const searchSetting = (e) => {
    const currValue = e.target.value;
    setInputSearchValue(currValue);
    const filteredData =
      inputSearchValue.length > 0 || inputSearchValue.length == 0
        ? filterArray(masterList, currValue)
        : filterArray(masterList, currValue);
    setDataSource(filteredData);
  };

  const filterArray = (dataSource, currValue) =>
    dataSource?.filter((o) =>
      o.title.toLowerCase().includes(currValue.toLowerCase())
    );

  const onClickHandler = (route, childPresent, id) => {
    if (childPresent) {
      navigate("/master-card-child", {
        state: id,
      });
    } else {
      if (route === "/client-onboarding") {
        localStorage.removeItem("clientId");
      }
      if (route === "/staff-onboarding") {
        localStorage.removeItem("staff");
      }
      navigate(route);
    }
  };
  return (
    <div className="master-container" style={{ padding: "3rem 5rem" }}>
      <Row gutter={30}>
        <MasterSearch
          title={headingTitle}
          search={searchSetting}
          masterSearch={window.location.pathname !== "/locking-management-dashboard" && window.location.pathname !== "/pending-awbs"}
          masterSearchPlaceholder={searchPlaceholder}
          isSearchPresent={searchPresent}
          setVisibleMasterList={() => {
            if (window.location.pathname === "/pending-awbs") {
              navigate("/locking-management-dashboard");
            } else {
              // Explicitly return to dashboard for all top-level menus instead of relying on history.back
              const userinfo = JSON.parse(localStorage.getItem("userinfo") || "{}");
              const userRoles = userinfo?.roles || [];
              if (userRoles.includes("ROLE_MD")) {
                navigate("/director-dashboardNew2");
              } else {
                navigate("/dashboard");
              }
            }
          }}
        />
        {window.location.pathname === "/mcn" && (
          <Col span={24}>
            <McnCounts />
          </Col>
        )}
        {window.location.pathname === "/locking-management-dashboard" && (
          <Col span={24}>
            <LockingManagement />
          </Col>
        )}
        {window.location.pathname === "/pending-awbs" && (
          <Col span={24}>
            <PendingAwbs />
          </Col>
        )}
        {window.location.pathname !== "/locking-management-dashboard" &&
          window.location.pathname !== "/pending-awbs" && (inputSearchValue.length == 0
            ? masterList.map((e) => {
              return (
                <MasterCard
                  key={e.id}
                  id={e.id}
                  title={e.title}
                  imgSrc={e.imgSrc}
                  onClickHandler={onClickHandler}
                  route={e.route}
                  searchTitle={searchPlaceholder}
                  disable={e.disable}
                  childPresent={e.childPresent}
                  isVerified={e.isVerified}
                />
              );
            })
            : dataSource.map((e) => {
              return (
                <MasterCard
                  key={e.id}
                  id={e.id}
                  title={e.title}
                  imgSrc={e.imgSrc}
                  onClickHandler={onClickHandler}
                  route={e.route}
                  searchTitle={searchPlaceholder}
                  disable={e.disable}
                  childPresent={e.childPresent}
                  isVerified={e.isVerified}
                />
              );
            }))}
      </Row>
    </div>
  );
};
export default Master;
